import { useAuth } from '../contexts/AuthContext';

export interface TaskFieldSettings {
  description: boolean;
  tags: boolean;
  horizon: boolean;
  recurrence: boolean;
  deadline: boolean;
  notes: boolean;
  parentTask: boolean;
  assignedTo: boolean;
  estimatedTime: boolean;
}

const defaultFieldSettings: TaskFieldSettings = {
  description: true,
  tags: true,
  horizon: true,
  recurrence: false,
  deadline: true,
  notes: true,
  parentTask: true,
  assignedTo: true,
  estimatedTime: false,
};

export const useTaskFieldSettings = (): TaskFieldSettings => {
  const { user } = useAuth();
  
  return {
    ...defaultFieldSettings,
    ...(user?.preferences?.taskFieldSettings || {})
  };
}; 